import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';
import { OptionProps } from './Option.types';

export const useStyles = ({
  isSelected,
  isFocused,
}: Pick<OptionProps, 'isSelected' | 'isFocused'>) => {
  const isActive = isSelected || isFocused;

  const styles = useStyleSheet(
    (theme) => ({
      root: {
        backgroundColor: isActive ? theme.palette.secondary.light : theme.palette.common.white,
        borderRadius: theme.borderRadius.sm,
        ':hover': {
          backgroundColor: theme.palette.secondary.light,
        },
      },
      label: {
        color: theme.palette.primary.main,
        fontSize: theme.fontSizes.h5,
      },
      labelValueContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
      },
      labelIcon: { minWidth: 14, minHeight: 14 },
    }),
    [isSelected, isFocused],
  );

  return styles;
};
